// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;He sent redemption to his people;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;he commanded his covenant for ever;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;holy and awesome is his name.<br> </p> </div></div>";
// Exports
module.exports = code;